import React, { FunctionComponent } from "react";
import styles from "./Search.module.css";
import SearchIcon from "../../../../../img/search.svg";
import CloseIcon from "../../../../../img/close.svg";

interface Props {
  search: string;
  setSearch: (search: string) => void;
}

const Search: FunctionComponent<Props> = ({ search, setSearch }: Props) => {
  return (
    <div className={styles.search}>
      <img src={SearchIcon} alt="Search" />
      <input
        data-testid="search-input"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={styles.searchInput}
        placeholder="Type to filter"
      />
      {search && search.length > 0 && (
        <img
          data-testid="clear-icon"
          src={CloseIcon}
          alt="Clear"
          onClick={() => setSearch("")}
          className={styles.clearSearch}
        />
      )}
    </div>
  );
};

export default Search;
